import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

type Props = {
  content: CmsApiPage;
};

export function getContentLocaleUrl({
  content,
}: Props): Record<string, string> {
  return (
    content.translations &&
    content.translations.reduce(
      (acc, cur) => {
        // eslint-disable-next-line no-param-reassign
        acc[cur.locale] = `/${cur.url}`;
        return acc;
      },
      {
        [content.locale]: `/${content.url}`,
      }
    )
  );
}
